module.exports = __webpack_public_path__ + "img/5.ef25f49d.png";